import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('import_manual_journal'),
    button: defineMessage('import'),
    warningText: defineMessage('important_uploading_a_f_lace_your_existing_data'),
    fileRequired: defineMessage('file_is_required'),
    downloadLinkText: defineMessage('download_template_file'),
    learnMoreText: defineMessage('learn_more'),
    description: defineMessage('approvalmax_allows_you__l_journal_as_a_csv_file'),
    rulesTitle: defineMessage('to_import_your_manual_journal_successfully'),
    rulesItemText1: defineMessage('do_not_alter_the_column_headings_in_the_template'),
    rulesItemText2: defineMessage('include_the_date_and_na_in_your_first_line_only'),
    rulesItemText3: defineMessage('date_format_must_be_or_dec'),
    rulesItemText4: defineMessage('do_not_import_more_than_lines_per_file'),
    dropzoneTitle: defineMessage('upload_csv_file_1'),
};
